import { Grid } from "@mui/material";
import CustomTextField from "../../components/Form/CustomTextField";
import CheckBox from "../../components/Form/CheckBox";
import CustomSelect from "../../components/Form/CustomSelect";
import CustomButton from "../../components/Form/CustomButton";
import Helpers from "../../helpers/helpers";

export default function BusinessInfoForm({ formObj, handleFormChange, handleRequestOTP, windowWidth, error }) {
    const dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'PH'];

    return (
        <Grid container spacing={1}>
            <Grid item sm={12}>
                <div className="text-semibold">Business Info</div>
                <div className="subheader-2">Add your business information</div>
            </Grid>
            <Grid item sm={12} xs={12}>
                <CustomTextField
                    values={formObj?.company_name}
                    onChange={(e) => handleFormChange('company_name', e)}
                    title={'Store name'}
                    placeholder={'Store name'}
                    error={error?.company_name}
                />
            </Grid>
            <Grid item sm={12} xs={12}>
                <CustomTextField
                    values={formObj?.registration_number}
                    onChange={(e) => handleFormChange('registration_number', e)}
                    title={'Registration number / UEN'}
                    placeholder={'Registration number / UEN'}
                    error={error?.registration_number}
                />
            </Grid>
            <Grid item sm={12} xs={12}>
                <CustomTextField
                    values={formObj?.company_description}
                    onChange={(e) => {
                        const value = e;
                        if (value.length <= 250) {
                            handleFormChange('company_description', e)
                        }
                    }}
                    title={'Short business description'}
                    placeholder={'Short business description'}
                    multiline={true}
                    rows={4}
                    subtitle={`${formObj?.company_description ? formObj.company_description.length : 0}/250 characters`}
                    error={error?.company_description}
                />
            </Grid>
            <Grid item sm={12} mt={2}>
                <div className="text-semibold">Opening hours</div>
                <div className="subheader-2">Set the workshop/office working hours to show on your profile page</div>
            </Grid>
            {
                dayList.map((day, idx) => {
                    const matchedIndex = formObj?.openingHours?.findIndex((item) => item?.day === day && item?.isChecked);
                    return (
                        <Grid item container sm={12} spacing={2}>
                            <Grid item sm={3} xs={3} className="d-flex align-items-center">
                                <CheckBox
                                    label={day}
                                    labelMarginLeft={windowWidth <= 425 ? 10 : 20}
                                    values={(formObj?.openingHours?.find((item) => item?.day === day && item?.isChecked)) || false}
                                    onChange={(e) => { handleFormChange('openingHours', day) }}
                                    fontSize={14}
                                />
                            </Grid>
                            <Grid item sm={4} xs={4}>
                                <CustomSelect
                                    title={'Opening time'}
                                    values={formObj?.openingHours?.find((item) => item?.day === day && item?.isChecked)?.open_time || '-1'}
                                    data={Helpers.timeList}
                                    disabled={!(formObj?.openingHours?.find((item) => item?.day === day && item?.isChecked))}
                                    onChange={(e) => handleFormChange('open_time', e, day)}
                                    placeholder={'Opening time'}
                                    error={matchedIndex > -1 ? error?.[`operation_hours.${matchedIndex}.open_time`] : null}

                                />
                            </Grid>
                            <Grid item sm={1} xs={1} className="d-flex align-items-center justify-content-center font-size-14">to</Grid>
                            <Grid item sm={4} xs={4}>
                                <CustomSelect
                                    values={formObj?.openingHours?.find((item) => item?.day === day && item?.isChecked)?.close_time || '-1'}
                                    data={Helpers.timeList}
                                    disabled={!(formObj?.openingHours?.find((item) => item?.day === day && item?.isChecked))}
                                    onChange={(e) => handleFormChange('close_time', e, day)}
                                    placeholder={'Closing time'}
                                    error={matchedIndex > -1 ? error?.[`operation_hours.${matchedIndex}.close_time`] : null}
                                />
                            </Grid>
                        </Grid>
                    )
                })
            }
            <Grid item sm={12} mt={2}>
                <div className="text-semibold">Key Contact Info</div>
                <div className="subheader-2">This person will become the first user under the dealer team.</div>
                <Grid container spacing={2}>
                    <Grid item sm={12} xs={12}>
                        <CustomTextField
                            values={formObj?.name}
                            onChange={(e) => handleFormChange('name', e)}
                            title={'Contact name'}
                            placeholder={'Contact name'}
                            error={error?.name}
                        />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <CustomTextField
                            values={formObj?.email}
                            onChange={(e) => handleFormChange('email', e)}
                            title={'Contact email'}
                            placeholder={'Contact email'}
                            error={error?.email}
                        />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <CustomTextField
                            values={formObj?.phone}
                            onChange={(e) => handleFormChange('phone', e)}
                            title='Phone Number'
                            placeholder='Phone Number'
                            type={'phone'}
                            InputProps={{
                                startAdornment: <div style={{ paddingLeft: 6, paddingRight: 10 }}>+65</div>,
                            }}
                            error={error?.phone}
                        />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <CustomTextField
                            values={formObj?.otp}
                            onChange={(e) => {
                                const value = e;
                                if (/^\d{0,6}$/.test(value)) {
                                    handleFormChange('otp', value);
                                }
                            }}
                            title='6-digit code'
                            placeholder='6-digit code'
                            type={'number'}
                            error={error?.otp}
                        />
                    </Grid>
                    <Grid item sm={6} xs={12} className="d-flex align-items-center" sx={{ order: { xs: 2, sm: 1 } }} >
                        <CustomButton
                            title={<div style={{ fontWeight: 400 }}>{` Get WhatsApp Verification Code`}</div>}
                            borderRadius={5}
                            paddingInline={"5px"}
                            press={() => { handleRequestOTP() }}
                            textColor={'#B48A3C'}
                            backgroundColor={'transparent'}
                            borderStyle={'none'}
                        /> {/* <span className="subheader-2">Resend code in </span><span className="mx-1">{'0.31'}</span> */}
                    </Grid>
                    <Grid xs={12} paddingLeft={"20px"} paddingTop={"10px"} sx={{ order: { xs: 1, sm: 2 } }}>
                        <span style={{ fontSize: 13, color: '#BDBDBD', marginTop: '5px', fontWeight: '400', }}><i className="ri-whatsapp-fill" style={{ color: '#25D366' }}></i> We'll send a 6-digit verification code to your phone number via WhatsApp </span>
                    </Grid>
                </Grid>
            </Grid>
        </Grid >
    )
}